import { BaseOption, OptionType } from './interfaces';

function isBaseOption(option: OptionType): option is BaseOption {
  return option && !!(option as BaseOption).hasOwnProperty('value');
}

export const DropdownInputOptionsTypeguards = {
  isBaseOption,
};
